import { toast } from "react-toastify";

export const enableCheckbox = () => {
    let checks = document.getElementsByClassName("PrivateSwitchBase-root");
    for (let i = 0; i < checks.length; i++) {
        checks[i].classList.remove("not-allowed-icon__clz");
    }
};

export const disableCheckbox = () => {
    let checks = document.getElementsByClassName("PrivateSwitchBase-root");
    for (let i = 0; i < checks.length; i++) {
        checks[i].classList.add("not-allowed-icon__clz");
    }
};

export async function getModeOfSales(userID: any, franchiseID: any, shopId: any, i18nextLng: any, setModeOfSales: Function) {
    const newList: any[] = [];
    await fetch(
        `${process.env.REACT_APP_API_V2_URL}/settings/general/mode_of_sale?userId=${userID}&franchiseId=${franchiseID}&shopId=${shopId}&type=activated`,
        {
            headers: {
                "Content-Type": "application/json",
                authorization: `Bareer ${localStorage.getItem("jwt")}`,
                "Accept-Language": i18nextLng,
            },

            method: "GET",
        }
    )
        .then((res) => res.json())
        .then(
            (result) => {
                for (let element of result.data) {
                    if (
                        element.Id ===
                        "8185fa67-f472-4173-a9b8-ec3dc79cd697" ||
                        element.Id ===
                        "d99758ef-0049-4513-90fe-ca44bd069aac"
                    ) {
                        newList.push({
                            label: element["Mode of sale"],
                            value: element.Id,
                        });
                    }
                }
                setModeOfSales(newList);
            },
            (error) => {
                console.log(error);
            }
        );
}

export async function getSite(t: any, dataLocation: any, setQrData: Function, schema: any, franchiseID: any, userID: any, i18nextLng: any, shopId: any): Promise<string | undefined> {

    return fetch(
        `${process.env.REACT_APP_API_V2_URL}/settings/list/c&c/domaine?schema=${schema}&shopId=${shopId}`,
        {
            headers: {
                "Content-Type": "application/json",
                authorization: `Bareer ${localStorage.getItem("jwt")}`,
                "Accept-Language": i18nextLng,
            },
            method: "GET",
        }
    )
        .then((res) => res.json())
        .then((result) => {
            const domaine = result.data?.[0]?.domaine;
            let formattedDomaine = domaine !== undefined ? domaine.startsWith("https") ? domaine : `https://${domaine}` : ""
            const shopData = result.data[0]

            const url =
                shopData !== undefined && shopData["Web site"] > 0
                    ? `${formattedDomaine}?place=${encodeURIComponent(dataLocation[t("Designation")])
                    }&id1=${franchiseID}&id2=${shopId}&${dataLocation.modeOfSale === null ? "" : 'id3=' + dataLocation.modeOfSale.value
                    }`
                    : `noSite?place=${encodeURIComponent(dataLocation[t("Designation")])
                    }&id1=${franchiseID}&id2=${shopId}&${dataLocation.modeOfSale === null ? "" : 'id3=' + dataLocation.modeOfSale.value

                    }`;
            setQrData(url);
            return url;
        })
        .catch((error) => {
            console.error("getSite error:", error);
            return undefined;
        });
}

export const copyUrl = (qrData: any, t: any) => {
    navigator.clipboard.writeText(qrData);
    toast.dismiss()
    toast.success(`${t("The QR code URL has been successfully copied")}`, {
        position: toast.POSITION.TOP_CENTER,
        theme: "colored",
    });
};
export const downloadQRCode = (id: string, qrCodeRefs: any, t: any) => {
    const qrContainer = qrCodeRefs.current[id];
    if (!qrContainer) return;
    const canvas = qrContainer.querySelector("canvas");
    if (!canvas) return;
    const image = canvas.toDataURL("image/png");
    const anchor = document.createElement("a");
    anchor.href = image;
    anchor.download = `qr-code-${id}.png`;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    toast.dismiss()
    toast.success(`${t("The QR code has been successfully downloaded.")}`, {
        position: toast.POSITION.TOP_CENTER,
        theme: "colored",
    });
};